import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import ReactSelect, { mergeStyles } from 'react-select';
import DropdownIndicator from './dropdown-indicator';
import LoadingIndicator from './loading-indicator';
import Option from './option';
import { useSelectStyles } from './select-styles';

const Select = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { error, components, styles, ...otherProps } = props;

  return (
    <ReactSelect
      ref={ref}
      placeholder={t('field.select_an_option')}
      menuShouldScrollIntoView
      menuPlacement="auto"
      {...otherProps}
      components={{
        DropdownIndicator,
        IndicatorSeparator: null,
        LoadingIndicator,
        Option,
        ...components,
      }}
      styles={mergeStyles(useSelectStyles(error), styles)}
    />
  );
});

Select.propTypes = {
  components: PropTypes.object,
  styles: PropTypes.object,
  error: PropTypes.bool,
};
Select.defaultProps = {
  components: undefined,
  styles: undefined,
  error: undefined,
};

export default Select;
